import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';

/**
 * Custom hook to initialize Intercom with user data
 * @param {Object} user - User object containing id, name, email, and createdAt
 */
export const useIntercom = (user) => {
  useEffect(() => {
    if (!user) {
      return;
    }

    Intercom({
      //spellchecker:disable-next-line
      app_id: 'ozzilao8',
      user_id: user._id,
      name: user.name,
      email: user.email,
      created_at: user.createdAt,
    });

    // Cleanup function to shutdown Intercom when component unmounts
    return () => {
      window.Intercom('shutdown');
    };
  }, [user]);
};
